const USER_SYNC_URL = 'https://pixel.servebom.com/partner';

export const getCacheBuster = (): number => Math.floor(Math.random() * 11000);

export const getUserSyncURL = (id: string | number, encode = true): string => {
  const url = `${USER_SYNC_URL}?cb=${getCacheBuster()}&svc=us&id=${id}&uid=`;

  return encode ? encodeURIComponent(url) : url;
};
